exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-dropdown[data-v-1d3eb1a0] {\n  color: #fff;\n}\n\n", "", {"version":3,"sources":["D:/地质云项目/DZYWebUI/src/layout/components/header/head.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb","file":"head.vue","sourcesContent":["\n.el-dropdown[data-v-1d3eb1a0] {\n  color: #fff;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d3eb1a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/components/header/head.vue
// module id = RpSA
// module chunks = 78